import axios from "axios";
import CryptoJS from "crypto-js";
import { getLocalStorageItem, getToken } from "../common/LocalStorageService";
import { logOutRedirectCall } from "../common/RedirectPathManage";
import Globals from "../common/utils";

var key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_KEY);
var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_IV);

const getLanguage = () => {
  const user = getLocalStorageItem("userData") || getLocalStorageItem("language");
  return user?.lang_code || 'en';
}

const axiosClient = axios.create({
  baseURL: Globals.APP_API_END_POINT,
  headers: {
    "api-key": bodyEncryption(process.env.REACT_APP_APP_NAME),
    "Accept-Language": getLanguage(),
    "Content-Type": "text/plain",
    type: "user",
    platform_type: "W"
  },
});

// Body Encryption Request
axiosClient.interceptors.request.use(function (request) {
  //   console.log(request.url, "==>", request.data);
  request.headers["Accept-Language"] = getLanguage();
  request.data = bodyEncryption(request.data, true);
  const token = getToken();
  if (token) {
    // console.log("token: ++++", token);
    request.headers["token"] = bodyEncryption(token);
  }
  return request;
});

axiosClient.interceptors.response.use(
  function (response) {
    response = bodyDecryption(response.data);
    // console.log("response: axiosss ", response);

    return response;
  },

  function (error) {
    console.log("error1: ===>", error);
    let res = error.response;
    if (!error.response) {
      console.log("error: ", error);
      return Promise.reject(error);
    }

    if (res.status === 401) {
      logOutRedirectCall();
      const response = bodyDecryption(res.data);
      return response;
    } else if (
      res.status === 400 ||
      res.status === 409 ||
      res.status === 500 ||
      res.status === 404
    ) {
      const response = bodyDecryption(res.data);
      return response;
    } else {
      console.error(
        "Looks like there was a problem. Status Code: " + res.status
      );
      return Promise.reject(error);
    }
  }
);

function bodyEncryption(request, isStringify) {
  var request_ = isStringify ? JSON.stringify(request) : request;
  var encrypted = CryptoJS.AES.encrypt(request_, key, { iv: iv });
  return encrypted.toString();
}

function bodyDecryption(request) {
  var decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

export { axiosClient };